export default __webpack_public_path__ + "static/media/Ashley_Swart.b07716a4.jpeg";